module.exports = __webpack_public_path__ + "img/vertical_7_2_6000.c9cb4010.png";